import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Badge from "./pages/Badge";
import Storie from "./pages/Storie";
import Group from "./pages/Group";
import Socialaccount from "./pages/Socialaccount";
import Password from "./pages/Password";
import AccountInfo from "./pages/AccountInfo";
import Settings from "./pages/Settings";
import Register from "./pages/Register";
import Forgot from "./pages/Forgot";
import Notfound from "./pages/Notfound";
import Comingsoon from "./pages/Comingsoon";
import Notification from "./pages/Notification";
import Email from "./pages/Email";
import Message from "./pages/Message";
import Live from "./pages/Live";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Shopone from "./pages/Shopone";
import Shoptwo from "./pages/Shoptwo";
import Payment from "./pages/Payment";
import Contactinfo from "./pages/Contactinfo";
import Video from "./pages/Video";
import GroupPage from "./pages/Grouppage";
import Userpage from "./pages/Userpage";
import Authorpage from "./pages/Authorpage";
import Eventpage from "./pages/Eventpage";
import Jobpage from "./pages/Jobpage";
import Hotelpage from "./pages/Hotelpage";
import Hotelsingle from "./pages/Hotelsingle";
import Helpbox from "./pages/Helpbox";
import Eamilopen from "./pages/Eamilopen";
import Singleproduct from "./pages/Singleproduct";
import Analytic from "./pages/Analytic";

import ClientPublicPage from "./pages/client-public";

import News from "./pages/News";
import NewsDetails from "./pages/NewsDetails";
import DonatePage from "./pages/DonatePage";
import DynamicClientPage from "./pages/DynamicClientPage";
import ClubPage from "./pages/ClubPage";
import ClubPosts from "./pages/ClubPosts";
import MatrimonyProfilePage from "./pages/MatrimonyProfilePage";
import MatrimonyViewProfile from "./pages/MatrimonyViewProfile";
import LoginPage from "./pages/LoginPage";
import CompleteProfilePage from "./pages/CompleteProfilePage";
import JoinClubPage from "./pages/JoinClubPage";
import ClubHomePage from "./pages/ClubHomPage";
import Users from "./pages/Users";

import MyClubsPage from "./components/MyClubs";
import ClubIndiaMap from "./components/ClubIndiaMap";

import LegalPage from "./pages/LegalPage";
import AboutPage from "./pages/AboutPage";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FeaturesPage from "./pages/FeaturesPage";
import PosterDesigns from "./pages/PosterDesign";
import WebsitePage from "./pages/WebsitePage";
import PublicFormPage from "./pages/PublicFormPage";
import AssignedForms from "./pages/AssignedForms";
import AssignedFormDetails from "./pages/AssignedFormDetails";
import AssignedFormResponse from "./pages/AssignedFormResponse";
import PaymentReturnPage from "./pages/PaymentReturnPage";
import PublicClubIndiaMap from "./pages/PublicClubIndiaMap";
import MediaAlbumDetailsPage from "./pages/MediaAlbumDetailsPage";
import EventDetailsPage from "./pages/EventDetailsPage";

const App = () => {
  return (
    <>
      <Routes>
        {/* =====================================================
            AUTHENTICATION ROUTES
        ===================================================== */}

        <Route path="/login" element={<LoginPage />} />

        <Route path="/register" element={<Register />} />

        <Route path="/forgot" element={<Forgot />} />

        <Route
          path="/complete-profile"
          element={<CompleteProfilePage />}
        />

        <Route
          path="/join-club"
          element={<JoinClubPage />}
        />

        {/* =====================================================
            MAIN HOME ROUTES
        ===================================================== */}

        <Route path="/" element={<LoginPage />} />

        <Route path="/home" element={<Home />} />

        {/* =====================================================
            NEWS ROUTES
        ===================================================== */}

        <Route path="/news" element={<News />} />

        <Route
          path="/news-details/:id"
          element={<NewsDetails />}
        />

        {/* =====================================================
            CLUB ROUTES
        ===================================================== */}

        <Route path="/clubs" element={<ClubPage />} />
        <Route
  path="/forms"
  element={<AssignedForms />}
/>
<Route
  path="/forms/:task_id"
  element={<AssignedFormDetails/>}
/>

<Route
  path="/forms/:task_id/response"
  element={<AssignedFormResponse/>}
/>
        <Route
          path="/club/:slug"
          element={<ClubHomePage />}
        />

        <Route
          path="/club-posts/:client_id"
          element={<ClubPosts />}
        />

        <Route
          path="/contacts"
          element={<MyClubsPage />}
        />

        <Route
          path="/clubs-map"
          element={<ClubIndiaMap />}
        />

<Route path="/designs/poster" element={<PosterDesigns/>} />

<Route
  path="/club/:slug/event/:eventId"
  element={<EventDetailsPage/>}
/>

<Route
  path="/club/:slug/media/:albumId"
  element={<MediaAlbumDetailsPage />}
/>
        {/* =====================================================
            MATRIMONY ROUTES
        ===================================================== */}

        <Route
          path="/matrimony/profile"
          element={<MatrimonyProfilePage />}
        />

        <Route
          path="/matrimony/viewprofile"
          element={<MatrimonyViewProfile />}
        />

        <Route
          path="/matrimony/viewprofile/:id"
          element={<MatrimonyViewProfile />}
        />

        {/* =====================================================
            USER AND ACCOUNT ROUTES
        ===================================================== */}

        <Route
          path="/users"
          element={<Users />}
        />

        <Route
          path="/socialaccount"
          element={<Socialaccount />}
        />

        <Route
          path="/password"
          element={<Password />}
        />

        <Route
          path="/accountinformation"
          element={<AccountInfo />}
        />

        <Route
          path="/defaultsettings"
          element={<Settings />}
        />

        <Route
  path="/payment/return"
  element={<PaymentReturnPage />}
/>

        {/* =====================================================
            DEFAULT SOCIAL APP ROUTES
        ===================================================== */}

        <Route
          path="/defaultbadge"
          element={<Badge />}
        />

        <Route
          path="/defaultstorie"
          element={<Storie />}
        />

        <Route
          path="/defaultgroup"
          element={<Group />}
        />

        <Route
          path="/defaultnotification"
          element={<Notification />}
        />

        <Route
          path="/defaultemailbox"
          element={<Email />}
        />

        <Route
          path="/defaultmessage"
          element={<Message />}
        />

        <Route
          path="/defaultlive"
          element={<Live />}
        />

        <Route
          path="/defaultvideo"
          element={<Video />}
        />

        {/* =====================================================
            SHOP AND PAYMENT ROUTES
        ===================================================== */}

        <Route path="/cart" element={<Cart />} />

        <Route
          path="/checkout"
          element={<Checkout />}
        />

        <Route path="/shop1" element={<Shopone />} />

        <Route path="/shop2" element={<Shoptwo />} />

        <Route
          path="/singleproduct"
          element={<Singleproduct />}
        />

        <Route
          path="/payment"
          element={<Payment />}
        />

        <Route
          path="/donate/:postId"
          element={<DonatePage />}
        />

        {/* =====================================================
            OTHER PAGE ROUTES
        ===================================================== */}

        <Route
          path="/contactinformation"
          element={<Contactinfo />}
        />

        <Route
          path="/grouppage"
          element={<GroupPage />}
        />

        <Route
          path="/userpage"
          element={<Userpage />}
        />

        <Route
          path="/authorpage"
          element={<Authorpage />}
        />

        <Route
          path="/defaultevent"
          element={<Eventpage />}
        />

        <Route
          path="/defaultjob"
          element={<Jobpage />}
        />

        <Route
          path="/defaulthotel"
          element={<Hotelpage />}
        />

        <Route
          path="/defaulthoteldetails"
          element={<Hotelsingle />}
        />

        <Route
          path="/helpbox"
          element={<Helpbox />}
        />

        <Route
          path="/defaultemailopen"
          element={<Eamilopen />}
        />

        <Route
          path="/defaultanalytics"
          element={<Analytic />}
        />

        <Route
          path="/comingsoon"
          element={<Comingsoon />}
        />

        <Route
          path="/notfound"
          element={<Notfound />}
        />

        {/* =====================================================
            DYNAMIC CLIENT PAGE
        ===================================================== */}

        <Route
          path="/pages/:slug"
          element={<DynamicClientPage />}
        />

        <Route
  path="/public-form/:slug"
  element={<PublicFormPage />}
/>

<Route
  path="/public-clubs-map"
  element={<PublicClubIndiaMap />}
/>

        {/* =====================================================
            LEGAL AND COMPANY ROUTES
        ===================================================== */}

<Route path="/home" element={<Home />} />

<Route path="/features" element={<WebsitePage />} />
<Route path="/about-us" element={<WebsitePage />} />
<Route path="/pricing" element={<WebsitePage />} />
<Route path="/contact-us" element={<WebsitePage />} />
<Route path="/terms-and-conditions" element={<WebsitePage />} />
<Route path="/privacy-policy" element={<WebsitePage />} />
<Route path="/return-cancellation-policy" element={<WebsitePage />} />
<Route path="/delete-account" element={<WebsitePage />} />
        {/* =====================================================
            PUBLIC CLIENT SLUG ROUTE

            Keep this route after all fixed single-segment routes.
            Examples:
            /jci-udupi
            /udupi-community
        ===================================================== */}

        <Route
          path="/:slug"
          element={<ClientPublicPage />}
        />

        {/* =====================================================
            404 ROUTE
        ===================================================== */}

        <Route
          path="*"
          element={<Notfound />}
        />
      </Routes>

      {/* =====================================================
          GLOBAL TOAST
      ===================================================== */}

      <ToastContainer
        position="top-right"
        autoClose={2000}
      />
    </>
  );
};

export default App;